const SmallPenIcon = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 15 14"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.14502 3.15705C9.53535 2.7665 10.1684 2.76623 10.559 3.15645L11.3423 3.93881C11.7331 4.32919 11.7334 4.96251 11.3429 5.35323L5.91776 10.7813C5.77847 10.9207 5.60113 11.0158 5.40798 11.0547L2.95001 11.55L3.44619 9.09479C3.48514 8.90204 3.58006 8.72505 3.71907 8.58597L9.14502 3.15705Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SmallPenIcon;
